import { render, staticRenderFns } from "./RelatorioProdutoEixo.vue?vue&type=template&id=290d102f&scoped=true"
import script from "./RelatorioProdutoEixo.vue?vue&type=script&lang=js"
export * from "./RelatorioProdutoEixo.vue?vue&type=script&lang=js"
import style0 from "./RelatorioProdutoEixo.vue?vue&type=style&index=0&id=290d102f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290d102f",
  null
  
)

export default component.exports